// form
import { Controller, useFormContext } from "react-hook-form";
// @mui
import { FormControlLabel, FormControlLabelProps } from "@mui/material";
import MySwitch from "../switch";

// ----------------------------------------------------------------------

type IProps = Omit<FormControlLabelProps, "control">;

interface Props extends IProps {
  name: string;
  label: string | React.ReactNode;
}

export default function RHFSwitch({ name, label, disabled, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      label={
        typeof label === "string" ? (
          <b style={{ color: "#657482" }}>{label}</b>
        ) : (
          label
        )
      }
      labelPlacement={other.labelPlacement ?? "top"}
      control={
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <MySwitch {...field} checked={field.value} disabled={disabled} />
          )}
        />
      }
      {...other}
      sx={{
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginLeft: 0,
        ...(other.sx || {}),
      }}
    />
  );
}
